import { Subscribe } from 'laco-inferno';

export default stores => Comp => props => (
  <Subscribe to={Array.isArray(stores) ? stores : [stores]}>
    {state => <Comp {...state} {...props} />}
  </Subscribe>
);